import { DateRangePicker, type DateRange } from "@/components/cinch/DatePicker";
import { cn } from "@/lib/utils";

export type KpiPeriod = "MTD" | "LAST_MONTH" | "QTD" | "LAST_QUARTER" | "YTD" | "CUSTOM";

const OPTIONS: { value: KpiPeriod; label: string }[] = [
  { value: "MTD", label: "MTD" },
  { value: "LAST_MONTH", label: "Last Month" },
  { value: "QTD", label: "QTD" },
  { value: "LAST_QUARTER", label: "Last Quarter" },
  { value: "YTD", label: "YTD" },
  { value: "CUSTOM", label: "Custom" },
];

export function PeriodSelector({
  value,
  onChange,
  rangeLabel,
  customRange,
  onCustomRangeChange,
}: {
  value: KpiPeriod;
  onChange: (next: KpiPeriod) => void;
  rangeLabel?: string;
  customRange: DateRange;
  onCustomRangeChange: (next: DateRange) => void;
}) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-wrap items-center gap-2">
        <span className="mr-1 text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
          Period
        </span>
        {OPTIONS.map((opt) => {
          const active = opt.value === value;
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => onChange(opt.value)}
              className={cn(
                "rounded-full border px-3.5 py-1.5 text-xs font-semibold transition-colors",
                active
                  ? "border-brand bg-brand text-white"
                  : "border-border bg-card text-muted-foreground hover:border-brand hover:text-brand",
              )}
            >
              {opt.label}
            </button>
          );
        })}
        {rangeLabel && (
          <span className="ml-auto text-xs text-muted-foreground">{rangeLabel}</span>
        )}
      </div>
      {value === "CUSTOM" && (
        <div className="flex flex-wrap items-center gap-2">
          <DateRangePicker value={customRange} onChange={onCustomRangeChange} />
          <span className="text-[11px] text-muted-foreground">
            Snaps to calendar months · up to 12 months, within the last 24
          </span>
        </div>
      )}
    </div>
  );
}
